import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "styled-components";
import PageWrapper from "../components/PageWrapper";
import { checkForUpdates } from "../utils/jsonUtils";
import { settings } from "../data/settings";
import theme from "../theme";
import SEO from "../components/SEO";

const CollaboratorContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
  ${theme.breakpoints.down("sm")} {
    padding: 1rem;
  }
`;

const CollaboratorWrapper = styled(Box)`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 2rem 0rem;
  max-width: ${({ maxWidth }) => maxWidth || "100%"};
  margin: 0 auto;
  border-bottom: 1px solid #444;
  background: black;
  color: white;
  padding: 2rem;

  ${theme.breakpoints.down("sm")} {
    flex-direction: column;
    padding: 1rem;

    margin: 0;
  }
`;

const CollaboratorImage = styled.div`
  flex: 1;
  & img {
    max-width: 300px;
    max-height: 300px;
    width: 100%;
    height: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    background-color: #ccc;
    filter: grayscale(100%);
    min-width: 200px;
    min-height: 200px;
  }
`;

const CollaboratorText = styled(Box)`
  max-width: 600px;
  color: white;
  font-size: 1rem;
  line-height: 1.6;

  & h5 {
    margin-bottom: 0;
    font-size: 1.8rem;
    font-weight: bold;
    text-transform: uppercase;
    color: white !important;
    line-height: 1.8rem;
    margin-block-start: 0;
    margin-block-end: 0;
  }

  & p {
    margin-bottom: 1rem;
    color: white !important;

    & span {
      color: white !important;
    }
  }

  & span {
    color: white !important;
  }
`;

const PageEquipe = ({ pageKey }) => {
  const [contentMap, setContentMap] = useState(null);

  useEffect(() => {
    checkForUpdates(pageKey, (data) => {
      const map = data.elements.reduce((acc, el) => {
        acc[el.id] = el.content;
        return acc;
      }, {});
      setContentMap(map);
    });
  }, [pageKey]);

  if (!contentMap) return <div>Chargement...</div>;

  const team = [
    { name: "Amélie", imgId: "img-amelie", txtId: "txt-amelie" },
    /*{ name: "Morgan", imgId: "img-morgan", txtId: "txt-morgan" },
    { name: "Nassiba", imgId: "img-nassiba", txtId: "txt-nassiba" },*/
  ];

  return (
    <PageWrapper style={{ backgroundColor: "#000" }}>
      <SEO pageKey={pageKey} />
      {contentMap && (
        <CollaboratorContent>
          {team.map(({ name, imgId, txtId }, index) => (
            <CollaboratorWrapper
              maxWidth={settings?.pages.pageMaxWidth}
              key={name}
              reverse={index % 2 !== 0}
            >
              {contentMap[imgId] && (
                <CollaboratorImage>
                  <img src={contentMap[imgId]} alt={name} />
                </CollaboratorImage>
              )}
              <CollaboratorText>
                <h5 variant="h5">{name},</h5>
                <p
                  dangerouslySetInnerHTML={{ __html: contentMap[txtId] || "" }}
                />
              </CollaboratorText>
            </CollaboratorWrapper>
          ))}
        </CollaboratorContent>
      )}
    </PageWrapper>
  );
};

export default PageEquipe;
